import { render } from "./CoachForm.vue?vue&type=template&id=a48b7e70&scoped=true"
import script from "./CoachForm.vue?vue&type=script&lang=js"
export * from "./CoachForm.vue?vue&type=script&lang=js"

import "./CoachForm.vue?vue&type=style&index=0&id=a48b7e70&scoped=true&lang=css"

import exportComponent from "D:\\Users\\וינברג\\Documents\\Vue\\main-prj-01-starting-setup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a48b7e70"]])

export default __exports__